<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'financial-financial-noInvoiceQuery',
  components: { PageTable },
}
</script>
